module.exports = __webpack_public_path__ + "img/37.4720ef7f.jpg";